/** Charges table shared by the partner Billing page and the admin Partner Billing page. */
import React from 'react';
import { StatusPill, money } from '../finance/financeUi';

const KIND = { setup: 'Setup fee', equipment: 'Equipment', subscription: 'Subscription' };

export function ChargesTable({ charges, actions, testid = 'charges-table', showPartner = false }) {
  if (!charges.length) return <p className="px-5 py-6 text-sm text-muted-foreground" data-testid={`${testid}-empty`}>No charges yet.</p>;
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm" data-testid={testid}>
        <thead className="text-left text-xs uppercase tracking-wide text-muted-foreground">
          <tr>{showPartner && <th className="px-5 py-2">Partner</th>}<th className="px-5 py-2">What</th><th className="px-3 py-2">Amount</th><th className="px-3 py-2">Status</th><th className="px-3 py-2">Date</th>{actions && <th className="px-3 py-2" />}</tr>
        </thead>
        <tbody className="divide-y">
          {charges.map((c) => (
            <tr key={c.charge_id} data-testid={`charge-row-${c.charge_id}`}>
              {showPartner && <td className="px-5 py-2">{c.partner}</td>}
              <td className="px-5 py-2"><p className="font-medium">{KIND[c.kind] || c.kind}</p><p className="text-xs text-muted-foreground">{c.description}</p>
                {c.last_error && <p className="text-xs text-destructive" data-testid={`charge-error-${c.charge_id}`}>{c.last_error}</p>}</td>
              <td className="px-3 py-2 tabular-nums">{money(c.amount)}</td>
              <td className="px-3 py-2"><StatusPill value={c.status} testid={`charge-status-${c.charge_id}`} /></td>
              <td className="px-3 py-2 text-xs text-muted-foreground">{new Date(c.paid_at || c.created_at).toLocaleDateString()}</td>
              {actions && <td className="px-3 py-2 text-right">{actions(c)}</td>}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
